// extracted by mini-css-extract-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1_LSs","cls2":"UserTaggingPingBodyStyles-cls2_xyZ UserTaggingPingBodyStyles-cls1_LSs"};